let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("30p9F")).then(() => parcelRequire('8FO5r'));